import MemberRequest from "../../MemberRequest";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("postBio")) {
    if (data.postBio === true || data.postBio === "true") res = true;
  }
  return res;
}


const sendBio = async function (bio ,pageAlerts,formAlerts) {
  let res=false;
  let req=new MemberRequest();
  req._formAlerts=formAlerts;
  req._pageAlerts=pageAlerts;
  req.query=`{postBio(bio:"""${bio}""")}`;
  res = await req.send(getResult);
  return res;
};

export default async function postBioApi(bio, pageAlerts,formAlerts) {
  return await sendBio(bio ,pageAlerts,formAlerts);
}
